import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'

import XText from '../../components/XText/XText'
import NewsAndArticles from '../../components/NewsAndArticles/NewsAndArticles'
import Button from '../../components/Button/Button'

import { httpPost } from '../../services/http'
import { getCommonLDScripts, getLDArticle } from '../../services/seo'

import { useCustomPagination } from '../../hooks/useCustomPagination'
import { useBrowserTab } from '../../hooks/useBrowserTab'

import './news.css'

const News = () => {
  const [pages, setPages] = useState([])

  useBrowserTab({ tabName: 'Новини' })

  useEffect(() => {
    httpPost('page/getAll')
      .then((resp) => {
        setPages(resp.data || [])
      })
  }, [])

  const {
    list: paginatedPages,
    prevDisabled,
    prevOnClick,
    nextDisabed,
    nextOnClick,
    page,
    pagesCount,
  } = useCustomPagination({ list: pages, per: 8 })

  return (
    <>
    <Helmet
      script={[
        ...getCommonLDScripts(),
        getLDArticle({
          name: 'Новини',
          createdAt: '01/05/2022',
          updatedAt: new Date().toLocaleDateString()
        }),
      ]}
    >
      <meta name='author' content='Xpart' />
      <meta name="robots" content="index,follow" />
      <meta name='theme-color' content='#1a7fc8' />
      <meta name='local' property='og:local' content='uk_UA' />
      <meta name='site_name' property='og:site_name' content={window.location.hostname} />
    </Helmet>
    <section className='news'>
      <div className='section__content'>
        <div className='section__title'><XText>Новини</XText>та стат’ї</div>
        <div className='flex-container--wrap'>
          <NewsAndArticles pages={paginatedPages} />
        </div>
        <div className='flex-container--bottom-70 flex-container--center'>
          <Button.Arrow
            className='xpa-button__arrow--without-margin'
            left
            disabled={prevDisabled}
            onClick={prevOnClick}
          />
          <div className='pagination__pages'>
            <span className='pagination__pages__current-page'>{page}</span>
            <span className='pagination__pages__available-pages'>/{pagesCount}</span>
          </div>
          <Button.Arrow
            disabled={nextDisabed}
            onClick={nextOnClick}
          />
        </div>
        <div></div>
      </div>
    </section>
    </>
  )
}

export default News
